import { ConnectedRouter as Router } from "connected-react-router";
import * as React from "react";
import "react-app-polyfill/ie11";
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import AppWrapper from "./components/utils/AppWrapper";
import Theme from "./components/utils/Theme";
import registerServiceWorker from "./registerServiceWorker";
import { applicationSagas } from "./sagas/rootSaga";
import { history, sagas, store } from "./store";

sagas.run(applicationSagas);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Theme>
        <AppWrapper>
          <App />
          {/*
            NOTE: The purpose of this empty node is to let react-sortable-hoc
            create a node that inherit the styles from the app during drag.
            It's necessary to set the 'helperContainer' property in the
            sortable containers.
          */}
          <div id="react-sortable-hoc-helper" />
        </AppWrapper>
      </Theme>
    </Router>
  </Provider>,
  document.getElementById("root")
);

registerServiceWorker();
